// Observe the real scrolling panel, including virtual lists whose last rows are spacers.
export function observeListPrefetch(marker: HTMLElement, onNearEnd: () => void, rows = 30) {
  let parent = marker.parentElement;
  while (parent && parent !== document.body && parent !== document.documentElement) {
    const style = getComputedStyle(parent);
    if (/(auto|scroll|overlay)/.test(`${style.overflowY} ${style.overflow}`)) break;
    parent = parent.parentElement;
  }
  const row = marker.parentElement?.querySelector<HTMLElement>('[data-track-row]');
  const stride = row ? row.getBoundingClientRect().height + 4 : 56;
  const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) onNearEnd();
  }, { root: parent && parent !== document.body && parent !== document.documentElement ? parent : null,
    rootMargin: `0px 0px ${Math.max(1, rows) * stride}px 0px` });
  observer.observe(marker);
  return () => observer.disconnect();
}
